import mixitup from 'mixitup';
/*************************************************/
/* SORTING                                       */
/*************************************************/

export function sorting() {
    const init = () => {

        if (document.querySelector('.references-overview__list')) {
            var references = mixitup('.references-overview__list', {
                animation: {
                    enable: false
                },
                callbacks: {
                    onMixStart: function (state) {
                        let mixElements = document.querySelectorAll('.references-overview__list .mix');
                        mixElements.forEach(x => {
                            x.classList.add('invisible');
                            x.classList.remove('hidden');
                        });
                    },
                    onMixEnd: function (state) {
                        let mixElements = document.querySelectorAll('.references-overview__list .mix');
                        mixElements.forEach(x => {
                            x.classList.remove('visible');
                            x.classList.remove('ReferenceGalleryCardTwoThirds');
                            x.classList.remove('ReferenceGalleryCardThreeThirds');
                            x.classList.remove('ReferenceGalleryCardOneThird');
                        });
            
                        state.show.forEach(x => {
                            x.classList.add('visible');
                        });

                        state.hide.forEach(x => {
                            x.classList.add('hidden');
                        });

                        mixElements = document.querySelectorAll('.references-overview__list .mix.visible');
                        mixElements.forEach((element, index) => {
                            index++; // Adjust index to be 1-based

                            switch (index % 8) {
                                case 1:
                                    element.classList.add('ReferenceGalleryCardTwoThirds');
                                    break;
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                    element.classList.add('ReferenceGalleryCardOneThird');
                                    break;
                                case 7:
                                    element.classList.add('ReferenceGalleryCardTwoThirds');
                                    break;
                                case 0: // This case handles the multiple of 8
                                    element.classList.add('ReferenceGalleryCardThreeThirds');
                                    break;
                                default:
                                    element.classList.add('ReferenceGalleryCardOneThird');
                                    break;
                            }
                        });

                        mixElements = document.querySelectorAll('.references-overview__list .mix');
                        mixElements.forEach(x => {
                            x.classList.remove('invisible');
                        });
                    }
                }
            });
        }
    };

    init();
}

